/* Nova — interazioni minime. Nessuna animazione d'ingresso: il sito sta fermo.
   Eccezione: lo slideshow dell'hero, con dissolvenza lenta. */
(function(){
  var d=document;
  var quiet=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // menu su schermi stretti
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-menu-toggle]'); if(!b) return;
    var n=d.getElementById('nav-primario'); if(!n) return;
    var ap=n.getAttribute('data-open')==='true';
    n.setAttribute('data-open',String(!ap)); b.setAttribute('aria-expanded',String(!ap));
  });

  // intestazione allo scorrimento: nascosta scendendo, visibile risalendo
  var hdr=d.querySelector('.hdr[data-scroll="hide"]');
  if(hdr){
    var last=window.scrollY, acc=0, SOGLIA=12, ticking=false;
    function onScroll(){
      var y=window.scrollY, delta=y-last; last=y;
      if(y<hdr.offsetHeight){ hdr.classList.remove('is-hidden'); acc=0; return; }
      acc=(delta>0)===(acc>0)?acc+delta:delta;          // accumula solo nella stessa direzione
      if(acc>SOGLIA){ hdr.classList.add('is-hidden'); acc=0; }
      else if(acc<-SOGLIA){ hdr.classList.remove('is-hidden'); acc=0; }
    }
    window.addEventListener('scroll',function(){
      if(ticking) return; ticking=true;
      requestAnimationFrame(function(){ onScroll(); ticking=false; });
    },{passive:true});
    // se il menu mobile è aperto, l'intestazione non deve sparire
    d.addEventListener('click',function(e){
      if(e.target.closest('[data-menu-toggle]')) hdr.classList.remove('is-hidden');
    });
  }

  // quantità nel carrello
  d.addEventListener('change',function(e){
    var q=e.target.closest('[data-cart-qty]'); if(q&&q.form) q.form.submit();
  });

  // slideshow hero
  d.querySelectorAll('[data-slideshow]').forEach(function(root){
    var slides=[].slice.call(root.querySelectorAll('[data-slide]'));
    var dots=[].slice.call(root.querySelectorAll('[data-goto]'));
    var sound=root.querySelector('[data-sound]');
    var i=0, timer=null;
    var auto=root.getAttribute('data-auto')==='true' && !quiet && slides.length>1;
    var wait=(parseInt(root.getAttribute('data-interval'),10)||6)*1000;

    function video(k){
      var vs=slides[k].querySelectorAll('video'); if(!vs.length) return null;
      for(var n=0;n<vs.length;n++){ if(vs[n].offsetParent!==null) return vs[n]; }
      return vs[0];
    }
    function show(k){
      slides[i].classList.remove('is-active'); if(dots[i]) dots[i].removeAttribute('aria-selected');
      var vOld=video(i); if(vOld){ vOld.pause(); }
      i=(k+slides.length)%slides.length;
      slides[i].classList.add('is-active'); if(dots[i]) dots[i].setAttribute('aria-selected','true');
      var v=video(i);
      if(v){ v.play().catch(function(){}); sound.hidden=false; sound.setAttribute('aria-pressed',String(!v.muted)); }
      else { sound.hidden=true; }
    }
    function next(){ show(i+1); }
    function start(){ if(auto){ stop(); timer=setInterval(next,wait); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }

    dots.forEach(function(b){ b.addEventListener('click',function(){ show(parseInt(b.getAttribute('data-goto'),10)); start(); }); });
    if(sound) sound.addEventListener('click',function(){
      var v=video(i); if(!v) return;
      v.muted=!v.muted; sound.setAttribute('aria-pressed',String(!v.muted));
      sound.setAttribute('aria-label', v.muted?"Attiva l'audio":"Disattiva l'audio");
    });
    root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',start);
    d.addEventListener('visibilitychange',function(){ d.hidden?stop():start(); });

    show(0); start();
    // nell'editor di Shopify, selezionare un blocco porta alla sua diapositiva
    d.addEventListener('shopify:block:select',function(e){
      var k=slides.indexOf(e.target.closest('[data-slide]')); if(k>-1){ stop(); show(k); }
    });
  });

  // finder: tre domande, una raccomandazione
  d.querySelectorAll('[data-finder]').forEach(function(root){
    var rules=JSON.parse(root.querySelector('[data-rules]').textContent);
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var ans={};
    function lista(s){ return (s||'').split(',').map(function(x){return x.trim();}).filter(Boolean); }
    function go(n){
      steps.forEach(function(el){ el.hidden = el.getAttribute('data-step')!==String(n); });
      root.scrollIntoView({behavior:quiet?'auto':'smooth',block:'start'});
    }
    function risultato(){
      var picks=lista(rules.base[ans.barba]);
      [ans.pelle, ans.scopo].forEach(function(k){ lista(rules.extra[k]).forEach(function(h){ if(picks.indexOf(h)<0) picks.push(h); }); });
      picks=picks.slice(0, rules.max);
      var grid=root.querySelector('[data-res-grid]');
      [].slice.call(grid.children).forEach(function(c){ c.hidden=true; c.style.order=''; });
      picks.forEach(function(h,i){ var c=grid.querySelector('[data-handle="'+h+'"]'); if(c){ c.hidden=false; c.style.order=i; } });
      root.querySelector('[data-res-testo]').textContent=rules.frasi[ans.barba]||'';
      go(4);
    }
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-pick]');
      if(b){
        var kv=b.getAttribute('data-pick').split('='); ans[kv[0]]=kv[1];
        var cur=parseInt(b.closest('[data-step]').getAttribute('data-step'),10);
        if(cur<3) go(cur+1); else risultato();
        return;
      }
      if(e.target.closest('[data-restart]')){ ans={}; go(1); }
    });
  });

  // scheda prodotto: barra «aggiungi al carrello» fissa su telefono
  var pdpBtn=d.querySelector('.pdp form .btn');
  var bar=d.querySelector('[data-sticky-buy]');
  if(pdpBtn && bar && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ bar.hidden = en[0].isIntersecting; },{threshold:0}).observe(pdpBtn);
    bar.querySelector('button').addEventListener('click',function(){ pdpBtn.click(); });
  }
})();
